import React from 'react';
import {Card, Form, Input, Row} from 'antd';
import PropTypes from 'prop-types';

import Editor from '../Editor';
import {massEmailDisclaimerText} from '../../helpers/text';

const {Meta} = Card;

const MassEmailForm = ({subject, setSubject, body, setBody, handleFinish}) => {
    const [form] = Form.useForm();

    const onSubjectChange = (e) => {
        e.preventDefault();
        const value = e.target.value.trim();

        setSubject(value);
    }

    const onBodyChange = (data) => {
        setBody(data);
    }

    return (
        <Form
            form={form}
            layout="vertical"
            id="mass-email-card-form"
            name="mass-email-card-form"
            onFinish={handleFinish}
            initialValues={{
                'Subject': subject,
                'Body': body,
            }}
        >
            <Form.Item name="Subject" label="Subject" rules={[{type: 'string', required: true, whitespace: true}]}>
                <Input onChange={onSubjectChange} style={{marginBottom: '10px'}}/>
            </Form.Item>
            <Form.Item name="Body" label="Body" rules={[{type: 'string', required: true}]}>
                <Editor existingContent={body} onChange={onBodyChange}/>
            </Form.Item>
            <Row>
                <Meta description={massEmailDisclaimerText}/>
            </Row>
        </Form>
    );
}

MassEmailForm.propsTypes = {
    subject: PropTypes.string,
    setSubject: PropTypes.func.isRequired,
    body: PropTypes.string,
    setBody: PropTypes.func.isRequired,
    handleFinish: PropTypes.func.isRequired
};

export default MassEmailForm;